import ApiService from '@/core/services/api.service';
import { makeToastFaile } from '@/utils/common';
import { BASE_URL } from '@/utils/constants';
import fileDownload from '@/utils/file-download';
import axios from 'axios';

/**
 * Service for handling approval list-related API calls
 */
export default {
  /**
   * Fetch approvals with pagination and filtering
   * @param {Object} params - Filter parameters
   * @returns {Promise} - Promise with the response data
   */
  fetchApprovals(params) {
    return ApiService.query('v1/approvals/', { params })
      .then((response) => response.data.data)
      .catch((error) => {
        console.error('Error fetching approvals:', error);
        throw error;
      });
  },

  /**
   * Delete an approval
   * @param {string|number} id - Approval ID
   * @returns {Promise} - Promise with the response data
   */
  deleteApproval(id) {
    return ApiService.delete(`v1/approvals/${id}`)
      .then((response) => response.data)
      .catch((error) => {
        console.error('Error deleting approval:', error);
        throw error;
      });
  },

  /**
   * Return an approval request
   * @param {string|number} id - Approval ID
   * @returns {Promise} - Promise with the response data
   */
  returnApproval(id) {
    return ApiService.put(`v1/approvals/${id}/return`)
      .then((response) => response.data)
      .catch((error) => {
        console.error('Error returning approval:', error);
        throw error;
      });
  },

  /**
   * Export approvals to Excel
   * @param {Object} params - Filter parameters
   * @returns {Promise} - Promise with the blob data
   */
  exportToExcel(params) {
    const url = `${BASE_URL}v1/approvals/export-excel`;
    return axios
      .get(url, {
        params,
        responseType: 'blob',
      })
      .then((response) => {
        const fileName = fileDownload.getFileName(response);
        fileDownload.createFile(response.data, fileName);
        return { success: true, fileName };
      })
      .catch((err) => {
        if (!err.response) {
          makeToastFaile('Lỗi!');
        } else {
          const message = err.response.data.message;
          makeToastFaile(message);
        }
        throw err;
      });
  },

  /**
   * Fetch stores available to the current user
   * @returns {Promise} - Promise with the store data
   */
  fetchStores() {
    return ApiService.get(`stores/get-by-user`)
      .then((response) => response.data.data.stores)
      .catch((error) => {
        console.error('Error fetching stores:', error);
        throw error;
      });
  },

  /**
   * Fetch employees for filtering
   * @returns {Promise} - Promise with the employee data
   */
  fetchEmployees() {
    return ApiService.get('/v1/employees/get-list-filter')
      .then((response) => response.data.data)
      .catch((error) => {
        console.error('Error fetching employees:', error);
        throw error;
      });
  },
};
